import angular from 'angular';
import ngMessages from 'angular-messages';
import constants from 'app/constants';
import {
  vmSharedModelService,
  orgDataService,
  reportsDataService
} from 'app/services';
import {
  pagination,
} from 'app/components/global';
import vendor from './vendor';
import directive from './vendors.directive';
import controller from './vendors.controller';


export default angular.module('app.components.advisory.vendorManagement.vendors', [
  ngMessages,
  constants,
  vendor,
  pagination,
  vmSharedModelService,
  orgDataService,
  reportsDataService
])
  .directive('vmVendors', directive)
  .controller('VendorsController', controller)
  .name;

console.log('app.components.advisory.vendorManagement.vendors created');
